import { z } from 'zod'

export const reorderExpenseTemplatesSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(100),
})

export type ReorderExpenseTemplatesDto = z.infer<typeof reorderExpenseTemplatesSchema>
